import * as React from 'react';
import { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';

import { AMOUNT, AVAILABLE_QTY, ID, IMAGE, ITEM_DETAILS, ORDER_STATE_PLACED, PRICE, PRODUCT, QUANTITY } from '../../../constants/string';
import { NumberFormatUtils } from '../../../utility/NumberFormatUtils';

function subtotal(items) {
  return items.map(({ Orderdetail }) => Orderdetail.unitprice * Orderdetail.quantity).reduce((sum, i) => sum + i, 0);
}

const OrderDataTable = ({ order, setPartialCancel, partialCancel }) => {
  const [quantities, setQuantities] = useState(
    order.orderData.orderdetail.reduce((acc, item) => {
      acc[item.Orderdetail.skunit_id] = item.Orderdetail.quantity;
      return acc;
    }, {})
  );

  const handleFulfillQuantityChange = (id, oldQuantity, updatedQuantity) => {
    if (updatedQuantity % 1 !== 0) {
      alert("Decimal values are not allowed");
      setQuantities(prev => ({ ...prev, [id]: oldQuantity }));
      return;
    }

    if (oldQuantity < updatedQuantity) {
      alert("You cannot increase quantity more than the original order");
      setQuantities(prev => ({ ...prev, [id]: oldQuantity }));
      return;
    }

    if (updatedQuantity < 0) {
      alert("You cannot have quantity less than 0");
      setQuantities(prev => ({ ...prev, [id]: oldQuantity }));
      return;
    }

    let totalQuantity = Object.values(quantities).reduce((total, qty) => total + qty, 0);

    if (totalQuantity === 0) {
      alert("You seem to be accepting 0 items. Please reject the order instead!");
      setQuantities(prev => ({ ...prev, [id]: oldQuantity }));
      return;
    }

    if (oldQuantity === updatedQuantity) {
      const { [id]: removed, ...newPartialCancel } = partialCancel;
      setPartialCancel(newPartialCancel);
    } else {
      setPartialCancel({ ...partialCancel, [id]: oldQuantity - updatedQuantity });
    }
  };

  return (
    <React.Fragment>
      <TableContainer component={Paper} sx={{
           marginTop: 2,
           border: '1px solid #ccc',
           borderRadius: 2,
           width: '100%',
           maxWidth: '97.5vw',
           overflowX: 'auto',
           marginX: 'auto',
           marginLeft: 1,
           marginRight: 1,
        }}>
        <Table aria-label="spanning table" >
          <TableHead>
            <TableRow>
              <TableCell
                align="center"
                variant="head"
                colSpan={order.orderData.Orderstate.namealias === ORDER_STATE_PLACED ? 7 : 6}
                sx={{
                  fontWeight: "bold",
                  fontSize: "medium",
                  backgroundColor: 'lightgray'
                }}
              >
                {ITEM_DETAILS}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="right" sx={{ fontWeight: "bold" }}>{ID}</TableCell>
              <TableCell align="right" sx={{ fontWeight: "bold" }}>{IMAGE}</TableCell>
              <TableCell align="right" sx={{ fontWeight: "bold" }}>{PRODUCT}</TableCell>
              <TableCell align="right" sx={{ fontWeight: "bold" }}>{QUANTITY}</TableCell>
              {order.orderData.Orderstate.namealias === ORDER_STATE_PLACED && (
                <TableCell align="right" sx={{ fontWeight: "bold" }}>{AVAILABLE_QTY}</TableCell>
              )}
              <TableCell align="right" sx={{ fontWeight: "bold" }}>{PRICE}</TableCell>
              <TableCell align="right" sx={{ fontWeight: "bold" }}>{AMOUNT}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {order.orderData.orderdetail.map((item) => (
              <TableRow key={item.Orderdetail.skunit_id}>
                <TableCell align="right">{item.Orderdetail.skunit_id}</TableCell>
                <TableCell align="right">
                  <img src={item.Skunit.pictureurl} alt={item.Skunit.name} style={{ width: '50px' }} />
                </TableCell>
                <TableCell align="right">{item.Skunit.name}</TableCell>
                <TableCell align="right">{item.Orderdetail.quantity}</TableCell>

                {order.orderData.Orderstate.namealias === ORDER_STATE_PLACED && (
                  <TableCell align="right">
                    <TextField
                      type="number"
                      value={quantities[item.Orderdetail.skunit_id]}
                      InputProps={{
                        inputProps: { min: 0, max: item.Orderdetail.quantity },
                      }}
                      onChange={(e) => {
                        const updatedQuantity = parseInt(e.target.value, 10);
                        setQuantities(prev => ({ ...prev, [item.Orderdetail.skunit_id]: updatedQuantity }));
                      }}
                      onBlur={(e) => {
                        const updatedQuantity = parseInt(e.target.value, 10);
                        handleFulfillQuantityChange(
                          item.Orderdetail.skunit_id,
                          item.Orderdetail.quantity,
                          updatedQuantity
                        );
                      }}
                    />
                  </TableCell>
                )}

                <TableCell align="right">
                  {NumberFormatUtils(item.Orderdetail.unitprice)}
                </TableCell>

                <TableCell align="right">
                  {NumberFormatUtils(item.Orderdetail.quantity * item.Orderdetail.unitprice)}
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell rowSpan={3} />
              <TableCell colSpan={order.orderData.Orderstate.namealias === ORDER_STATE_PLACED ? 5 : 4} sx={{ fontWeight: "bold" }}>Total</TableCell>
              <TableCell align="right" sx={{ fontWeight: "bold" }}>
                {NumberFormatUtils(subtotal(order.orderData.orderdetail))}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
}

export default OrderDataTable;
